(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  let novaleePrivacyScript;

  const loadNovaleePrivacyScript = () => {
    if (window.privacyBanner?.showPreferences) return Promise.resolve();
    if (novaleePrivacyScript) return novaleePrivacyScript;
    novaleePrivacyScript = new Promise((resolve, reject) => {
      const source = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      let script = document.querySelector(`script[src="${source}"]`);
      const timer = window.setTimeout(() => reject(new Error('Privacy banner unavailable')), 15000);
      const finish = () => {
        window.clearTimeout(timer);
        window.privacyBanner?.showPreferences ? resolve() : reject(new Error('Privacy banner unavailable'));
      };
      if (!script) {
        script = document.createElement('script');
        script.src = source;
        script.async = true;
        script.addEventListener('load', finish, { once: true });
        script.addEventListener('error', () => {
          window.clearTimeout(timer);
          reject(new Error('Privacy banner unavailable'));
        }, { once: true });
        document.head.appendChild(script);
      } else {
        script.addEventListener('load', finish, { once: true });
      }
    }).catch((error) => {
      novaleePrivacyScript = undefined;
      throw error;
    });
    return novaleePrivacyScript;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-novalee-cookie-settings]');
    if (!button) return;
    const message = button.parentElement.querySelector('[data-novalee-cookie-error]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    message.hidden = true;
    try {
      await new Promise((resolve, reject) => {
        if (window.Shopify?.customerPrivacy) return resolve();
        if (!window.Shopify?.loadFeatures) return reject(new Error('Customer privacy unavailable'));
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          error ? reject(error) : resolve();
        });
      });
      await loadNovaleePrivacyScript();
      const preferencesVisible = new Promise((resolve, reject) => {
        let observer;
        const check = () => {
          const dialog = document.getElementById('shopify-pc__prefs__dialog');
          if (!dialog || dialog.getClientRects().length === 0) return;
          window.clearTimeout(timer);
          observer?.disconnect();
          resolve();
        };
        const timer = window.setTimeout(() => {
          observer?.disconnect();
          reject(new Error('Privacy preferences were not displayed'));
        }, 15000);
        observer = new MutationObserver(check);
        observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
      });
      await Promise.all([window.privacyBanner.showPreferences({ locale: 'de', country: 'DE' }), preferencesVisible]);
    } catch {
      message.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novalee-store-map"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('novalee-store-map')) {
    customElements.define('novalee-store-map', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const loadButton = this.querySelector('[data-map-load]');
        const closeButton = this.querySelector('[data-map-close]');
        const placeholder = this.querySelector('[data-map-placeholder]');
        const frame = this.querySelector('[data-map-frame]');
        const status = this.querySelector('[data-map-status]');
        const options = { signal: this.abortController.signal };
        let mapUrl;
        try {
          mapUrl = new URL(this.dataset.mapUrl);
          if (mapUrl.protocol !== 'https:' || !['www.google.com', 'google.com'].includes(mapUrl.hostname) || !/^\/maps\/embed(?:\/|$)/.test(mapUrl.pathname)) return;
        } catch {
          return;
        }
        loadButton?.addEventListener('click', () => {
          if (frame.firstElementChild) return;
          const iframe = document.createElement('iframe');
          iframe.title = this.dataset.mapTitle;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.allowFullscreen = true;
          iframe.src = mapUrl.href;
          status.textContent = this.dataset.loadingText;
          iframe.addEventListener('load', () => { status.textContent = this.dataset.loadedText; }, { once: true });
          frame.append(iframe);
          placeholder.hidden = true;
          closeButton.hidden = false;
          closeButton.focus({ preventScroll: true });
        }, options);
        closeButton?.addEventListener('click', () => {
          frame.replaceChildren();
          closeButton.hidden = true;
          placeholder.hidden = false;
          status.textContent = this.dataset.closedText;
          loadButton?.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
